import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';
import { Popup } from '@techsoftware/happay-widgets';
// import TickGreen from '../../assets/images/tick.svg';
import Icon from '@techsoftware/happay-widgets/FontIcon';
import TickGreen from '../../assets/images/tick-green.svg';
import Locales from '../../constants/locales';
const ErrorConstants = Locales.JSON.common;

const ValidationPolicy = props => {
  const returnPasswordValidation = validation => (
    <Grid
      direction="column"
      container
      style={{ color: 'white' }}
      className="padding-30 fadeIn"
    >
      <Grid
        direction="row"
        container
        alignItems="center"
        className="margin-b-20 column-heading white"
        style={validation.capital ? { opacity: '' } : {}}
      >
        {!validation.capital ? (
          <img src={TickGreen} alt="tick" className="tick-icon fadeIn" />
        ) : (
          <div className="empty-circle"></div>
        )}
        {ErrorConstants.UPPERCASE_ERROR}
      </Grid>
      <Grid
        direction="row"
        alignItems="center"
        container
        className="margin-b-20 column-heading white"
        style={validation.special ? { opacity: '0.5' } : {}}
      >
        {!validation.special ? (
          <img src={TickGreen} alt="tick" className="tick-icon fadeIn" />
        ) : (
          <div className="empty-circle"></div>
        )}
        {ErrorConstants.SPECIALCHAR_ERROR}
      </Grid>
      <Grid
        direction="row"
        alignItems="center"
        container
        className="column-heading white"
        style={validation.length ? { opacity: '0.5' } : {}}
      >
        {!validation.length ? (
          <img src={TickGreen} alt="tick" className="tick-icon fadeIn" />
        ) : (
          <div className="empty-circle"></div>
        )}
        {ErrorConstants.NO_OF_CHARS_ERROR}
      </Grid>
    </Grid>
  );

  return (
    <Popup
      id="passwordValidation"
      open={props.openValidationPopup}
      pointerPlacement="left-center"
      backgroundColor="#0b1322"
      variant="scroll"
      popupStyle={{ width: '248px', top: '-20px' }}
    >
      {returnPasswordValidation(props.passwordValidationList)}
    </Popup>
  );
};

ValidationPolicy.propTypes = {
  passwordValidationList: PropTypes.object,
  openValidationPopup: PropTypes.bool,
};

export default ValidationPolicy;
